<!-- h5页面常用的局部标题样式 -->
<template>
  <div :class="$style.sectionTitle">
    <img :src="`${cdnLink}/box_vip/title.png`" alt="" />
    <p>{{title}}</p>
    <img
      :src="`${cdnLink}/box_vip/title.png`"
      alt=""
      :class="$style.titleImg"
    />
  </div>
</template>

<script>
import { CDN_URL_1 } from "@/config";

export default {
  props: {
    title: String,
  },
  data() {
    return {
        cdnLink: CDN_URL_1 ,
    };
  },
  methods: {},
};
</script>

<style lang="scss" module>
.sectionTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  > p {
    font-size: 17px;
    font-weight: 700;
    text-align: center;
    color: #864e1d;
    margin: 0 8px;
  }
  > img {
    width: 64px;
  }
  .titleImg {
    transform: rotate(180deg);
  }
}
</style>
